import { NavLink, useLocation } from 'react-router-dom';

type SidebarLinkProps = {
  to: string;
  label: string;
  activePattern?: RegExp | ((pathname: string) => boolean);
};

export const SidebarLink = ({ to, label, activePattern }: SidebarLinkProps) => {
  const location = useLocation();
  
  const isCustomActive = activePattern
    ? typeof activePattern === 'function'
      ? activePattern(location.pathname)
      : activePattern.test(location.pathname)
    : false;

  return (
    <NavLink
      to={to}
      className={({ isActive }) => {
        const active = isActive || isCustomActive;
        return (
          'group relative flex items-center gap-2.5 rounded-md px-4 text-sm duration-300 ease-in-out hover:text-white ' +
          (active ? 'font-bold text-primary' : 'font-light text-secondary')
        );
      }}
    >
      {label}
    </NavLink>
  );
};
